import * as React from 'react'
import * as SwaggerUI from 'swagger-ui'
import { Fetch } from '../Fetch'
import { FetchResult } from '../Fetch'

import 'swagger-ui/dist/swagger-ui.css'

export interface SwaggerProps {
  apiId: string;
}

export class Swagger extends React.Component<SwaggerProps, any> {

  constructor(props: SwaggerProps) {
    super(props)
  }

  initSwagger(spec: any) {
    SwaggerUI({
      dom_id: "#ui",
      spec: spec,
      layout: 'BaseLayout',
      defaultModelExpandDepth: 0,
      defaultModelsExpandDepth: 0,
      displayRequestDuration: true,
      presets: [
        SwaggerUI.presets.apis
      ]
    })
  }

  errorComponent(error: Error) {
    console.error(error)
    return <div>Error: could not fetch</div>
  }

  render() {
    return (
      <div>
        <Fetch resource="Swagger" apiId={this.props.apiId}>
          {
            (fetchResult: FetchResult): JSX.Element => {
              if (fetchResult.error) {
                return this.errorComponent(fetchResult.error)
              }
              else if (!fetchResult.loading) {
                this.initSwagger(fetchResult.result)
                return null
              }
            }
          }
        </Fetch>
        <div id="ui" />
      </div>
    )
  }
}
